<template lang="html">
  <section class="sub-main take-place column actualities">
		<div class="ctn-articles take-place column">
			<div class="ctn-columns row" id="my-actualities-columns">
				<div class="column-article">
					<custom-article-small v-if="isColumnsFilled" :article="article" v-for="(article, key) in colsMyActualities[0]" v-bind:key="key"/>
				</div>
				<div class="column-article">
					<custom-article-small v-if="isColumnsFilled" :article="article" v-for="(article, key) in colsMyActualities[1]" v-bind:key="key"/>
				</div>
			</div>
		</div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomArticleSmall from '@/common/components/article-small'

export default {
	name: 'Actualities',
	components: {
		CustomArticleSmall
	},
	data () {
		return {
			colsMyActualities: [[], []]
		}
	},
	mounted () {
		this.init()
	},
	methods: {
		init () {
			this.colsMyActualities = [[], []]

			if (!this.myNews || this.myNews.length === 0) {
				this.fillColumn(this.allNews, this.colsMyActualities)
			} else {
				this.fillColumn(this.myNews, this.colsMyActualities)
			}
		},
		fillColumn (start, end) {
			start.forEach(article => {
				let sizeA = 0
				let sizeB = 0
				end[0].forEach(item => {
					sizeA += (item.size === 'big') ? 1 : 0.5
				})
				end[1].forEach(item => {
					sizeB += (item.size === 'big') ? 1 : 0.5
				})
				const foo = (sizeA <= sizeB) ? end[0] : end[1]
				foo.push(article)
			})

			this.isColumnsFilled = true
		}
	},
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous',
			myNews: 'myNews',
			allNews: 'allNews'
		})
	},
	watch: {
		myNews () {
			this.init()
		},
		allNews () {
			this.init()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Actualities/MyActualities.vue